import { FormattedMessage } from 'react-intl';
import OverlayTrigger from '@rio-cloud/rio-uikit/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/Tooltip';

import useHoverIntent from '@/hooks/useHoverIntent';

interface ReadingNotPossibleProps {
    onHoverIntent?: () => void;
}

const ReadingNotPossible = ({ onHoverIntent }: ReadingNotPossibleProps) => {
    const [hoverRef] = useHoverIntent(1000, () => {
        onHoverIntent?.();
    });

    return (
        <div className="display-flex align-items-center" style={{ minWidth: '160px' }}>
            <span className="text-size-14 text-color-darkest">
                <FormattedMessage id="intl-msg:engineOil.state.reading_not_possible" />
            </span>
            <OverlayTrigger
                placement="top"
                overlay={
                    <Tooltip>
                        <FormattedMessage id="intl-msg:engineOil.olderThan24h" />
                    </Tooltip>
                }
            >
                <span
                    ref={hoverRef}
                    className="rioglyph rioglyph-info-sign text-color-dark text-size-14 margin-left-5 cursor-pointer"
                />
            </OverlayTrigger>
        </div>
    );
};

export default ReadingNotPossible;
